import React from 'react';

const UserIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">
                        account_circle
                  </span>
            </>
      );
};

export default UserIcon;
